<template>
    <div class="edit_category_name" :data-indicador="indicador">
        <h2 class="food_item_Category" :data-indicador="indicador" v-if="!editActive" @click.prevent="activeEdit()">{{ cat.name_cat }}</h2>
        <div class="content-editor" v-else>
            <textarea
                v-model="cat.name_cat"
                class="widget_edit_category_name"
                placeholder="Category Name"
                maxlength="50"
                ref="editName_cat"
                @keypress="noEnter"
                @change="saveCatName()"
                @focusout="inactiveEdit"
            ></textarea>
        </div>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
export default {
    components: {
        VueEditor,
    },
    props: ['indicador', 'cat'],
    data(){
        return {
            loadSave: false,
            editActive: false,
            apis: null,
        };
    },
    created(){
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bMenu;
    },
    methods: {
        activeEdit(){
            let t = this;
            t.editActive = true;
            setTimeout(() => {
                if(t.$refs.editName_cat){
                    t.$refs.editName_cat.focus();
                }
            }, 200);
        },
        inactiveEdit(){this.editActive = false;},
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.saveCatName()
            }
        },
        saveCatName(){
            let t= this;
            t.inactiveEdit()
            let urlService = t.apis.set(0)// setCat
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, t.cat)
                .then((response) => {
                    console.log(urlService, t.cat, response.data);
                    t.loadSave = false;
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error",
                        text: "Could not be save!",
                    });
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .edit_category_name {
        .food_item_Category{
            border: 1px dashed transparent;
            &:hover{
                border: 1px dashed #fcd602;
            }
        }
        textarea.widget_edit_category_name{
            width: 100%;
            height: 50px;
            font-size: 2rem;
            text-align: center;
            padding: 0px;
            resize: none;
            overflow: hidden;
            box-shadow: none;
            outline: none;
        }
    }
</style>
